import {
  BaseComboboxInputProps,
  ComboboxInput,
} from "@/lib/Components/Form/Inputs/ComboboxInput";
import {
  blogAuthorListQuery,
  blogAuthorRecordQuery,
  BlogAuthorListItem,
} from "@/app/Blogs/GraphQL/blogAuthorQueries";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { BlogAuthorCreateDialog } from "@/app/Blogs/Components/BlogAuthorCreateDialog";
import { BlogAuthorEditDrawer } from "@/app/Blogs/Components/BlogAuthorEditDrawer";

export function BlogAuthorInput(
  props: BaseComboboxInputProps<
    ResultOf<typeof blogAuthorListQuery>,
    VariablesOf<typeof blogAuthorListQuery>,
    BlogAuthorListItem,
    ResultOf<typeof blogAuthorRecordQuery>,
    VariablesOf<typeof blogAuthorRecordQuery>
  >,
) {
  const { openAsPromise } = useDialog(BlogAuthorCreateDialog);
  const { open: openEditDrawer } = useDialog(BlogAuthorEditDrawer);

  return (
    <ComboboxInput
      document={blogAuthorListQuery}
      accessor={(data) => data.blogAuthors}
      getQueryVariables={() => ({})}
      recordDocument={blogAuthorRecordQuery}
      recordAccessor={(data) => data.blogAuthor!}
      getViewNode={(i) =>
        i ? (
          <button
            type="button"
            onClick={() => openEditDrawer({ authorId: i.id })}
            className="text-blue-600 hover:underline"
          >
            {i.name}
          </button>
        ) : (
          "--"
        )
      }
      getInputNode={(i) => i.name}
      getListItemNode={(i) => i.name}
      getKey={(i) => i.id}
      fixture={(search) => ({
        label: search ? `Add ${search}` : "Add new author",
        onClick() {
          return openAsPromise({
            initialValues: search ? { name: search } : undefined,
          });
        },
      })}
      {...props}
    />
  );
}
